// v1.1 CEL-390: hide only these links; retain payloads and backend APIs.
const withoutERP = ['RRE', 'RFE', 'URE', 'PCR'];
const withoutRetrieval = ['IIE', 'TIE', 'MBE', 'RRE', 'RFE', 'URE', 'PCR', '2PT', 'NCE', 'LFS', 'NSE'];

export const eventLinks = (type: string, role?: string) => ({
  showERP: !withoutERP.includes(type),
  showRetrieval: role === 'itadmin' && !withoutRetrieval.includes(type),
});
